import $ from 'jquery';
import {Component} from '../../../component';
export class CheckoutForm extends Component {

    /**
     * Constructor
     */
    constructor(context) {
        super(context);

        this.$formEl = $('form.checkout');
    }

    /**
     * setup
     */
    setup() {
        this.$formEl.on('change', 'input#ship-to-billing-address-checkbox', this.onShipToBillingAddressChange.bind(this));
        this.$formEl.on('change blur', 'input[name^="billing_"], select[name^="billing_"], textarea[name^="billing_"]', this.onBillingAddressChange.bind(this));
        this.$formEl.find('input#ship-to-billing-address-checkbox').change();
        $(document.body).off('click', 'a.woocommerce-terms-and-conditions-link');
    }

    /**
     * shipToBillingAddress
     */
    onShipToBillingAddressChange(evt) {
        const isChecked = $(evt.target).is(':checked');

        if (isChecked) {
            $('input#ship-to-different-address-checkbox').prop('checked', false).change();

            $('.billing_address input[name^="billing"], .billing_address textarea[name^="billing"], .billing_address select[name^="billing"]').each((i, el) => {
                const $el = $(el);
                const field = $el.attr('name').replace('billing', '');

                $('input[name="shipping' + field +'"], textarea[name="shipping' + field +'"], select[name="shipping' + field +'"]')
                    .val($el.val())
                    .change();
            });

            this.disableShippingAddress();
        } else {
            $('input#ship-to-different-address-checkbox').prop('checked', true).change();

            $('.shipping_address input[name^="shipping"], .shipping_address textarea[name^="shipping"], .shipping_address select[name^="shipping"]').each((i, el) => {
                const $el = $(el);
                const $rowEl = $el.closest('.form-row');

                $el.prop('disabled', false);
                $el.not(':hidden').val($el.data('value')).change();

                $rowEl.removeClass('woocommerce-invalid').removeClass('woocommerce-validated');
            } );
        }
    }

    /**
     * shipToBillingAddress
     */
    onBillingAddressChange(evt) {
        const $el = $(evt.target);
        const field = $el.attr('name').replace('billing', '');
        const isChecked = $('input#ship-to-billing-address-checkbox').is(':checked');

        if (isChecked) {
            $('input[name="shipping' + field +'"], textarea[name="shipping' + field +'"], select[name="shipping' + field +'"]')
                .val($el.val())
                .change();

            this.disableShippingAddress();
        } else {
            $('input[name="shipping_first_name"]').val($('input[name="billing_first_name"]').val()).change();
            $('input[name="shipping_last_name"]').val($('input[name="billing_last_name"]').val()).change();
        }
    }

    /**
     * shipToBillingAddress
     */
    disableShippingAddress() {
        $('.shipping_address input[name^="shipping"], .shipping_address textarea[name^="shipping"], .shipping_address select[name^="shipping"]').each((i, el) => {
            const $el = $(el);
            const $rowEl = $el.closest('.form-row');

            $el.prop('disabled', true);
            $rowEl.removeClass('woocommerce-invalid').removeClass('woocommerce-validated');
        });
    }
}
